export const formatRewardAmount = (value: number | undefined, language?: string, fallback = '-'): string => {
  if (typeof value !== 'number' || !Number.isFinite(value)) return fallback;
  return new Intl.NumberFormat(language?.startsWith('fr') ? 'fr-CA' : 'en-CA', {
    maximumFractionDigits: 2,
  }).format(value);
};
